import React, { useEffect, useRef, useState } from "react"
import Icon from "../icon/icon.component"
import ClipSpinner from "../spinner/ClipSpinner"
import { FormattedInputWithActionsProps } from "../types/input"
import "./QuantityInputWithActionsStyles.scss"
import FormattedInputField from "../../sharedComponents/formattedInputField.component"

export const FormattedInputWithActions = (props: FormattedInputWithActionsProps) => {
    const [value, setValue] = useState(props.value)
    const [isFocused, setIsFocused] = useState(false)
    const [isBlur, setIsBlur] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const inputGroupRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        setIsLoading(false)
        setIsBlur(true)
        setIsFocused(false)
        setValue(props.value)
    }, [props.value])

    const onFocus = () => {
        setIsFocused(true)
        setIsBlur(false)
    }

    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const {relatedTarget} = event

        if (inputGroupRef.current && !inputGroupRef.current.contains(relatedTarget as Node)) {
            handleClose()
        }
    }

    const handleChange = (e) => {
        setValue(e)
    }

    const handleSave = () => {
        if (!value) {
            setValue(props.value)
            setIsBlur(true)
            setIsFocused(false)
            return
        }
        if (value !== props.value) {
            setIsLoading(true)
            props.onSaveCallback(value)
        }
    }

    const handleClose = () => {
        if (!isLoading) {
            setIsBlur(true)
            setTimeout(() => {
                setIsFocused(false)
                setValue(props.value)
            }, 230)
        }
    }

    return (
        <div
            className={"input-group input-group-container "}
            onBlur={handleBlur}
            ref={inputGroupRef}
        >
            <FormattedInputField
                className={"form-control"}
                onFocus={onFocus}
                value={value}
                onValueChange={e => handleChange(e)}
            />

            {isFocused &&
                <div
                    className={"input-group-append input-group-button-container " + (!isBlur ? "fade-in" : "fade-out")}>
                    <button
                        className={"input-group-text btn btn-outline-success" + (isLoading ? " input-save-loading" : "")}
                        onClick={() => handleSave()}
                    >
                        {!isLoading
                            ? <Icon value="check" className="pr-1"/>
                            : <ClipSpinner
                                height="20px"
                                width="24px"
                                size={16}
                            />
                        }

                    </button>
                    <button className="input-group-text btn-outline-secondary" onClick={() => handleClose()}>
                        <Icon value="times" className="pr-1"/>
                    </button>
                </div>
            }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/common/inputs/FormattedInputWithActions.tsx